import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useState, useEffect } from "react";
import { v4 } from "uuid";
import { db, storage } from "../utils/firebase";
import SuccessfulCommunity from "./SuccessfulCommunity";

export default function AddCommunity() {
  const [isForm, setIsForm] = useState(true);
  const [community, setCommunity] = useState("");
  const [budget, setBudget] = useState();
  const [description, setDescription] = useState();
  const [imageUpload, setImageUpload] = useState(null);
  const [loading, setLoading] = useState(false);
  const [adminEmailList, setAdminEmailList] = useState([]);
  const [warning, setWarning] = useState("");

  useEffect(() => {
    async function getUser() {
      const docRef = doc(db, "Users", localStorage.getItem("id"));
      const result = await getDoc(docRef);
    }

    getUser();

    async function getAdminEmailList() {
      const q = query(
        collection(db, "Users"),
        where("userTypeNumber", "==", 4)
      );

      const adminArray = await getDocs(q);
      setAdminEmailList(
        adminArray.docs.map((doc) => {
          return doc.data().email;
        })
      );
    }
    getAdminEmailList();
  }, []);

  async function sendEmail() {
    await addDoc(collection(db, "mail"), {
      to: adminEmailList,
      message: {
        subject: `${community} has been created`,
        html: `
          New Community Created
        `,
      },
    });
  }

  const AddCommunity = (e) => {
    e.preventDefault();

    try {
      if (community === undefined) {
        setWarning("Enter Community Name");
      } else if (description === undefined) {
        setWarning("Enter Description");
      }
      // else if (imageUpload === null) {
      //   alert("Enter image");
      // }
      else {
        setLoading(true);
        sendEmail();
        // const imageRef = ref(storage, `Communities/${imageUpload.name + v4()}`);
        // uploadBytes(imageRef, imageUpload)
        //   .then((snapshot) => {
        //     getDownloadURL(snapshot.ref).then((url) => {
        addDoc(collection(db, "Communities"), {
          name: community,
          totalFunds: 0,
          fundsUsed: 0,
          description,
          img: "https://picsum.photos/200/200",
          status: "pending",
          slug: community.replace(/\s/g, ""),
          nft: "(addHere)",
          //   });
          // });
        })
          .then(() => {
            setLoading(false);
            setIsForm(!isForm);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="container">
      {isForm ? (
        <form className="login-form mb-5">
          <div className="row">
            <div className="col-12">
              <div className="mb-3">
                <label
                  className="my-1 mr-2"
                  htmlFor="inlineFormCustomSelectPref"
                >
                  Create a Community
                </label>
              </div>
              <div className="mb-3">
                <label className="form-label small fw-bold">
                  Community Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="s"
                  required
                  placeholder="Enter Community Name"
                  value={community}
                  onChange={(e) => setCommunity(e.target.value)}
                />
              </div>
            </div>
            <div className="col-12">
              <div className="mb-3">
                <label className="form-label small fw-bold">
                  Description <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  name="description"
                  required
                  placeholder="Description :"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
            {/* <div className="col-12">
              <div className="mb-3">
                <label className="form-label small fw-bold">
                  Image Upload <span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  onChange={(e) => {
                    setImageUpload(e.target.files[0]);
                  }}
                />
              </div>
            </div> */}

            <div className="col-12">
              <div className="mb-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue
                    required
                    id="flexCheckDefault"
                  />
                  <label
                    className="form-check-label small fw-bold"
                    htmlFor="flexCheckDefault"
                  >
                    I Accept{" "}
                    <a href="#" className="text-primary">
                      Terms And Condition
                    </a>
                  </label>
                  {loading ? (
                    <div style={{ marginLeft: -24 }}>
                      <div
                        className="spinner-border text-primary"
                        style={{ display: "flex", margin: "2em auto" }}
                        role="status"
                      >
                        <span className="visually-hidden">
                          Creating Community...
                        </span>
                      </div>
                      <p className="text-center mx-auto">
                        Creating Community...
                      </p>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-12">
              <button className="btn btn-primary w-100" onClick={AddCommunity}>
                Create Community
              </button>
              <p className="text-danger text-center">{warning}</p>
            </div>
          </div>
        </form>
      ) : (
        <SuccessfulCommunity community={community} />
      )}
    </div>
  );
}
